/**
 * Class representing the Timeline timeline.
 *
 * Made with Flow
 */
class Timeline {
    /**
     * Returns the timeline's duration in milliseconds.
     */
    static get duration() { return 2800 }

    static artboardAnimation() {
        // Workaround for Safari bug
        return document.querySelector('#Timeline.flow-artboard').animate({
            backgroundPosition: ['0px', '1px'],
        }, {
            delay: 0,
            duration: 2800,
        });
    }
    static cellAnimation0() {
        return document.querySelector('#Timeline .cell').animate({
            top: ['55.14px', '95.14px'],
            opacity: [0, 1],

        }, {
            delay: 0,
            duration: 1200,
            easing: 'ease-in-out',
            composite: 'add',
            fill: 'forwards',
        });
    }
    static posterAnimation0() {
        return document.querySelector('#Timeline .poster').animate({
            left: ['142.62px', '182.62px'],
            opacity: [0, 1],

        }, {
            delay: 800,
            duration: 1200,
            easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
            composite: 'add',
            fill: 'forwards',
        });
    }
    static accountAnimation0() {
        return document.querySelector('#Timeline .account').animate({
            opacity: [0, 1],
            left: ['562.62px', '522.62px'],

        }, {
            delay: 1600,
            duration: 1200,
            easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
            composite: 'add',
            fill: 'forwards',
        });
    }

    /**
     * Creates and returns all animations for this timeline.
     */
    static createAllAnimations() {
        return [
            this.artboardAnimation(),
            this.cellAnimation0(),
            this.posterAnimation0(),
            this.accountAnimation0(),
        ]
    }
}

Timeline.allShapes = [
    document.querySelector("#Timeline .rectangle-svg"),
    document.querySelector("#Timeline .path-svg"),
    document.querySelector("#Timeline .rectangle_1-svg"),
    document.querySelector("#Timeline .shape-svg"),
    document.querySelector("#Timeline .shape_1-svg"),
    document.querySelector("#Timeline .shape_2-svg"),
    document.querySelector("#Timeline .shape_3-svg"),
    document.querySelector("#Timeline .rectangle_2-svg"),
    document.querySelector("#Timeline .path_1-svg"),
    document.querySelector("#Timeline .rectangle_3-svg"),
    document.querySelector("#Timeline .path_2-svg"),
    document.querySelector("#Timeline .path_3-svg"),
    document.querySelector("#Timeline .shape_4-svg"),
    document.querySelector("#Timeline .shape_5-svg"),
    document.querySelector("#Timeline .rectangle_4-svg"),
    document.querySelector("#Timeline .path_4-svg"),
    document.querySelector("#Timeline .rectangle_5-svg"),
    document.querySelector("#Timeline .shape_6-svg"),
    document.querySelector("#Timeline .shape_7-svg"),
    document.querySelector("#Timeline .shape_8-svg"),
    document.querySelector("#Timeline .shape_9-svg"),
    document.querySelector("#Timeline .shape_10-svg"),
    document.querySelector("#Timeline .shape_11-svg"),
    document.querySelector("#Timeline .shape_12-svg"),
    document.querySelector("#Timeline .shape_13-svg"),
    document.querySelector("#Timeline .shape_14-svg"),
    document.querySelector("#Timeline .shape_15-svg"),
    document.querySelector("#Timeline .shape_16-svg"),
    document.querySelector("#Timeline .shape_17-svg"),
    document.querySelector("#Timeline .shape_18-svg"),
    document.querySelector("#Timeline .shape_19-svg"),
]

Object.freeze(Timeline)

export default Timeline
